import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import {
  ETooltipSide,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from 'components/ui/tooltip';

interface ISettingsTileProps {
  title: string;
  tooltip: string;
  testId?: string;
  children: React.ReactNode;
}

export const SettingsTile = ({
  title,
  tooltip,
  testId,
  children
}: ISettingsTileProps): React.ReactElement => (
  <div
    className="flex w-full flex-col gap-4 rounded-[10px] border border-base-border p-[17px]"
    data-testid={testId}
  >
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-base-foreground">{title}</span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-pointer text-base-mutedForeground hover:text-base-foreground">
              <FontAwesomeIcon icon="fa-regular fa-circle-question" />
            </div>
          </TooltipTrigger>
          <TooltipContent
            side={ETooltipSide.Right}
            align="center"
            className="z-[1001] max-w-[280px] rounded-md border border-base-popover bg-base-popover px-[12px] py-[6px] shadow-md"
          >
            <span className="text-p-s text-base-popoverForeground">{tooltip}</span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    {children}
  </div>
);
